import { compact, map } from 'lodash-es'
import { forceArray } from '#app/lib/utils'
import type { LatLng } from '#server/types/common'

type DocWithPosition = { position?: LatLng }

export function getDocsBounds (docsWithPosition: DocWithPosition[] | DocWithPosition) {
  docsWithPosition = forceArray(docsWithPosition)
  return compact(map(docsWithPosition, 'position'))
}
